import { render, staticRenderFns } from "./RedactionIcon.vue?vue&type=template&id=3d8d39c2&"
import script from "./RedactionIcon.vue?vue&type=script&lang=js&"
export * from "./RedactionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports